import { render } from "./GoalDetailsModal.vue?vue&type=template&id=2876e10e&scoped=true"
import script from "./GoalDetailsModal.vue?vue&type=script&lang=js"
export * from "./GoalDetailsModal.vue?vue&type=script&lang=js"

import "./GoalDetailsModal.vue?vue&type=style&index=0&id=2876e10e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2876e10e"]])

export default __exports__